<template>
  <div class="w-100 d-block" :style="`z-index:${1000 + depth}`">
    <b-form-radio-group v-model="choice" class="mb-2" :options="item.choices"></b-form-radio-group>
    <h-t-table
      v-if="item.transactions.length"
      class="w-100 border-right border-left border-bottom border-semi-dark sm"
      :table-hover="false"
    >
      <template #table-head>
        <h-t-table-header-action
          v-if="item.choice !== 'credit' && item.choice !== 'refund'"
          tiny
          side="left"
        ></h-t-table-header-action>
        <h-t-table-header>NUMÉRO</h-t-table-header>
        <h-t-table-header>CLIENT</h-t-table-header>
        <h-t-table-header>LIEU DE STOCKAGE</h-t-table-header>
        <h-t-table-header>DATE DE CRÉATION</h-t-table-header>
        <h-t-table-header>QUANTITÉS</h-t-table-header>
        <h-t-table-header>STATUT</h-t-table-header>
      </template>
      <template #table-body>
        <template v-for="transaction in item.transactions">
          <tr :key="transaction.transaction.id" class="cursor-pointer bg-white">
            <h-t-table-element-action
              v-if="item.choice !== 'credit' && item.choice !== 'refund'"
              side="left"
              tiny
              @click.native="transaction.open = !transaction.open"
            >
              <i v-if="transaction.open" class="bx bx-chevron-up bx-sm text-primary"></i>
              <i v-else class="bx bx-chevron-down bx-sm text-primary"></i>
            </h-t-table-element-action>
            <h-t-table-element @click.native="goToTransaction(transaction.transaction.id)">{{
              transaction.transaction.number
            }}</h-t-table-element>
            <h-t-table-element @click.native="goToTransaction(transaction.transaction.id)">{{
              transaction.transaction.organization_object.company_name
            }}</h-t-table-element>
            <h-t-table-element @click.native="goToTransaction(transaction.transaction.id)">{{
              transaction.transaction.stockage_area_object.name
            }}</h-t-table-element>
            <h-t-table-element @click.native="goToTransaction(transaction.transaction.id)">{{
              transaction.transaction.created_at | formatData
            }}</h-t-table-element>
            <h-t-table-element @click.native="goToTransaction(transaction.transaction.id)">{{
              transaction.transaction.total_quantity
            }}</h-t-table-element>
            <h-t-table-element
              v-if="transaction.name !== 'invoice'"
              @click.native="goToTransaction(transaction.transaction.id)"
            >
              <h-e-rectangle
                
                :title="formatStatus(transaction.transaction.status, transaction.status, transaction.colors).status"
                color-full
                :bg-color="formatStatus(transaction.transaction.status, transaction.status, transaction.colors).color"
              ></h-e-rectangle>
            </h-t-table-element>
            <h-t-table-element v-else>
              <h-e-rectangle
                :title="
                  formatStatus(transaction.transaction.payment_status, transaction.status, transaction.colors).status
                "
                color-full
                :bg-color="
                  formatStatus(transaction.transaction.payment_status, transaction.status, transaction.colors).color
                "
              ></h-e-rectangle>
            </h-t-table-element>
          </tr>
          <tr v-if="transaction.open" :key="transaction.transaction.id + 1">
            <td colspan="7">
              <tree-table
                :transactions="transaction.transactions"
                class="w-100 my-4 px-3"
                :item="transaction"
                :depth="depth + 1"
                @getTransaction="getTransaction"
              ></tree-table>
            </td>
          </tr>
        </template>
      </template>
    </h-t-table>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'tree-table',

  filters: {
    formatData(date) {
      return moment(date).format('DD/MM/YYYY')
    },
  },

  props: {
    depth: {
      type: Number,
      default: 0,
    },
    transactions: {
      type: Array,
      default: () => [],
    },
    item: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      choice: this.item.choice,
    }
  },

  watch: {
    choice() {
      this.getTransaction({ transactionId: this.item.transaction.id, choice: this.choice })
      // eslint-disable-next-line vue/no-mutating-props
      this.item.choice = this.choice
    },
  },

  methods: {
    getTransaction(event) {
      this.$emit('getTransaction', event)
    },

    formatStatus(status, statusChoices, colorChoices) {
      if (status) {
        return {
          status: statusChoices.find((statusChoice) => statusChoice.value === status).text,
          color: colorChoices[status],
        }
      }
      return {
        color: null,
        status: null,
      }
    },

    goToTransaction(id) {
      this.$router.push({ name: this.item.choice.replace('_', '-'), params: { id } })
    },
  },
}
</script>

<style scoped></style>
